// extracted by mini-css-extract-plugin
module.exports = {"md":"maps-tabbar-item_md_3ip5D","ios":"maps-tabbar-item_ios_1C78d","link":"maps-tabbar-item_link_3wEZa"};